// TODO replace with axios

import { CSRF_TOKEN_HEADER_KEY } from "../constants";
import { getCsrfToken } from "utils";

const apiService = {
  defaultOptions: {
    headers: {
      "content-type": "application/json",
    },
    credentials: "include",
    referrerPolicy: "origin",
  },
  getDefaultOptions() {
    return {
      ...this.defaultOptions,
      headers: {
        ...this.defaultOptions.headers,
        [CSRF_TOKEN_HEADER_KEY]: getCsrfToken(),
      },
    };
  },
  combineOptions(options) {
    if (!options) {
      return this.getDefaultOptions();
    }
    const { headers, ...other } = this.getDefaultOptions();
    const { headers: optionsHeaders, ...otherOptions } = options;
    const tmpHeaders = {
      ...headers,
      ...optionsHeaders,
    };
    const preparedOptions = Object.keys(tmpHeaders).reduce((a, key) => {
      if (tmpHeaders[key]) {
        a[key] = tmpHeaders[key];
      }
      return a;
    }, {});
    return {
      headers: preparedOptions,
      ...other,
      ...otherOptions,
    };
  },
  get(url, options) {
    return fetch(url, { method: "GET", ...this.combineOptions(options) });
  },
  post(url, options) {
    return fetch(url, { method: "POST", ...this.combineOptions(options) });
  },
  put(url, options) {
    return fetch(url, { method: "PUT", ...this.combineOptions(options) });
  },
  patch(url, options) {
    return fetch(url, { method: "PATCH", ...this.combineOptions(options) });
  },
  delete(url, options) {
    return fetch(url, { method: "DELETE", ...this.combineOptions(options) });
  },
};

export default apiService;
